import React, { useState, useEffect } from "react";
import EcommStats from "./child/EcommStats";
import SalesOverviewChart from "./child/SalesOverviewChart";
import TopSellingProductsTable from "./child/TopSellingProductsTable";
import TopCustomersTable from "./child/TopCustomersTable";
import DashboardApi from "../Api/DashboardApi";

const DashBoardLayerEight = () => {
  const [filter, setFilter] = useState("Day");
  const [stats, setStats] = useState({
    totalOrders: 0,
    totalProducts: 0,
    totalCustomers: 0,
    totalRevenue: 0
  });
  const [statsLoading, setStatsLoading] = useState(false);

  useEffect(() => {
    fetchStats();
  }, [filter]);

  const fetchStats = async () => {
    setStatsLoading(true);
    try {
      const response = await DashboardApi.getStats(filter);
      if (response.status && response.response.data) {
        setStats(response.response.data);
      }
    } catch (error) {
      console.error("Error fetching stats:", error);
    } finally {
      setStatsLoading(false);
    }
  };

  return (
    <>
      <div className="row gy-4">
        {/* Dashboard Header */}
        <div className="col-12 mb-2">
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 p-2 bg-white radius-8 shadow-sm px-24 py-16">
            <h5 className="mb-0 fw-bold text-primary-light">Dashboard</h5>
            <div className="btn-group" role="group">
              {["Day", "Weekly", "Monthly", "Yearly"].map((f) => (
                <button
                  key={f}
                  type="button"
                  className={`btn btn-sm px-20 py-8 ${filter === f ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => setFilter(f)}
                >
                  {f}
                </button>
              ))}
            </div>
          </div>
        </div>
        
        <div className="col-12">
          {/* Top Summary Stats */}
          <EcommStats stats={stats} loading={statsLoading} />

          {/* Sales Overview Chart */}
          <SalesOverviewChart filter={filter} />

          <div className="row gy-4">
             <div className="col-xxl-6">
                {/* Top Selling Products */}
                <TopSellingProductsTable filter={filter} />
             </div>
             <div className="col-xxl-6">
                {/* Top Customers */}
                <TopCustomersTable filter={filter} />
             </div>
          </div>
        </div>
      </div>
    </>
  );
};



export default DashBoardLayerEight;
